export function cloneClassInstance<T>(instance: Partial<T>): T {
    const copy = new (instance.constructor as { new (): T })();
    Object.assign(copy, instance);
    return copy;
}
